import React, {useState} from "../../_snowpack/pkg/react.js";
import {DescriptionList} from "../../_snowpack/pkg/@patternfly/react-core.js";
import {KeycloakSpinner} from "../../components/keycloak-spinner/KeycloakSpinner.js";
import {useAdminClient, useFetch} from "../../context/auth/AdminClient.js";
import {DetailDescription} from "./DetailDescription.js";
import "./detail-cell.css";
export const DetailCell = ({id, clientId, uris}) => {
  const adminClient = useAdminClient();
  const [scope, setScope] = useState();
  const [permissions, setPermissions] = useState();
  useFetch(() => Promise.all([
    adminClient.clients.listScopesByResource({
      id: clientId,
      resourceName: id
    }),
    adminClient.clients.listPermissionsByResource({
      id: clientId,
      resourceId: id
    })
  ]), ([scopes, permissions2]) => {
    setScope(scopes);
    setPermissions(permissions2);
  }, []);
  if (!permissions || !scope) {
    return /* @__PURE__ */ React.createElement(KeycloakSpinner, null);
  }
  return /* @__PURE__ */ React.createElement(DescriptionList, {
    isHorizontal: true,
    className: "keycloak_resource_details"
  }, /* @__PURE__ */ React.createElement(DetailDescription, {
    name: "uris",
    array: uris
  }), /* @__PURE__ */ React.createElement(DetailDescription, {
    name: "scopes",
    array: scope,
    convert: (s) => s.name
  }), /* @__PURE__ */ React.createElement(DetailDescription, {
    name: "associatedPermissions",
    array: permissions,
    convert: (p) => p.name
  }));
};
